import { Palette, TypographyVariantsOptions } from "@mui/material/styles";

export const typography:
  | TypographyVariantsOptions
  | ((palette: Palette) => TypographyVariantsOptions) = {
  button: {
    fontSize: "16px",
    textTransform: "inherit",
    fontFamily: "Roboto-Regular, sans-serif",
  },
};
